import {
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
} from '@mui/material';
import { LoadState } from '../../../types/LoadState';
import { BostadAutocompleteDto } from '../../types/dtos/VarderingarModel';

interface LagenheterSelectProps {
  lagenhetsnummers: BostadAutocompleteDto[];
  loadState: LoadState;
  selectedValue: string;
  setSelectedValue: (value: BostadAutocompleteDto) => void;
}

export const LagenheterSelect: React.FC<LagenheterSelectProps> = ({
  lagenhetsnummers,
  loadState,
  selectedValue,
  setSelectedValue,
}) => (
  <FormControl
    size="small"
    disabled={lagenhetsnummers.length === 0 || loadState === LoadState.Loading}
    sx={{ minWidth: 175 }}
  >
    <InputLabel>
      {loadState === LoadState.Loading ? (
        <CircularProgress size={20} />
      ) : (
        'Lägenhetsnummer'
      )}
    </InputLabel>
    <Select
      label="Lägenhetsnummer"
      value={selectedValue || ''}
      onChange={(e) =>
        setSelectedValue(
          lagenhetsnummers.find((l) => l.lagenhetsnummer === e.target.value)
        )
      }
    >
      {lagenhetsnummers.map((lagenhetsnummer) => (
        <MenuItem
          value={lagenhetsnummer.lagenhetsnummer}
          key={lagenhetsnummer.id}
        >
          {lagenhetsnummer.lagenhetsnummer}
        </MenuItem>
      ))}
    </Select>
  </FormControl>
);
